<div class="revamped-sidebar">
    <!-- Top Section with unified background #FBFBFB -->
    <div class="top-section">
        <!-- Header Banner with Gradient Background -->
        <div class="header-banner gradient-banner"></div>

        <!-- Profile Avatar - Positioned to overlap header -->
        <div class="profile-avatar-container">
            <div class="profile-avatar-large" [style.background-color]="getAvatarColor(getFullName())">
                <img *ngIf="hasValidPhoto(selectedUser)" [src]="selectedUser.photo" [alt]="getFullName()"
                    class="avatar-image" (error)="onImageError($event, selectedUser)" (load)="onImageLoad($event)" />
                <span class="avatar-initials" [style.display]="hasValidPhoto(selectedUser) ? 'none' : 'flex'">
                    {{ getInitials(getFullName()) }}
                </span>
            </div>
        </div>

        <!-- Profile Info Section - Name, Email, Short ID -->
        <div class="profile-info-section">
            <div class="name-with-badge">
                <h2 class="candidate-name-large">{{selectedUser?.first_name || '-'}} {{selectedUser?.last_name || '-'}}
                </h2>
            </div>
            <div class="candidate-meta-row">
                <span class="candidate-email copyable-text" (click)="copyToClipboard(selectedUser?.email, 'Email')"
                    title="Click to copy">
                    <i class="pi pi-envelope"></i>
                    {{selectedUser?.email || '-'}}
                </span>
                <span class="meta-separator">•</span>
                <span class="candidate-short-id copyable-text" (click)="copyToClipboard(selectedUser?.uuid, 'ID')"
                    title="Click to copy">
                    <i class="pi pi-copy"></i>
                    {{selectedUser?.uuid?.slice(-12) || '-'}}
                </span>
            </div>
        </div>

        <!-- Tab Navigation - Pill Style (Only 2 tabs) -->
        <div class="new-tab-nav">
            <button class="new-tab" [class.active]="activeTab === 'personal'" (click)="activeTab = 'personal'">
                <i class="pi pi-user"></i>
                <span>Personal</span>
            </button>
            <button class="new-tab" [class.active]="activeTab === 'events'" (click)="onEventsTabClick()">
                <i class="pi pi-file-edit"></i>
                <span>Event Details</span>
            </button>
        </div>
    </div>

    <!-- Content Section with background #FCFBFF - Only for Personal Tab -->
    <div class="content-section" *ngIf="activeTab === 'personal'">
        <!-- Personal Tab Content -->
        <div class="personal-tab-content" *ngIf="activeTab === 'personal'">

            <!-- Primary Details Section -->
            <div class="details-section-card">
                <h3 class="section-title-new">Primary Details</h3>
                <div class="primary-details-grid">
                    <div class="primary-detail-item">
                        <div class="detail-icon-wrapper">
                            <i class="pi pi-mars detail-svg-icon"></i>
                        </div>
                        <div class="detail-text-content">
                            <span class="detail-label-new">GENDER</span>
                            <span class="detail-value-new">{{ formatEducationValue(selectedUser?.gender) || '-' }}</span>
                        </div>
                    </div>
                    <div class="primary-detail-item">
                        <div class="detail-icon-wrapper">
                            <i class="pi pi-calendar detail-svg-icon"></i>
                        </div>
                        <div class="detail-text-content">
                            <span class="detail-label-new">DATE OF BIRTH</span>
                            <span class="detail-value-new">{{ selectedUser?.date_of_birth || '-' }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Resume Section - Show if loading or resume exists -->
            <div class="details-section-card" *ngIf="pdfSrc || isLoadingResume">
                <h3 class="section-title-new">Resume</h3>

                <!-- Loading State -->
                <div class="resume-loading" *ngIf="isLoadingResume">
                    <i class="pi pi-spin pi-spinner"></i>
                    <span>Loading resume...</span>
                </div>

                <!-- Resume Link -->
                <div class="resume-link-wrapper" *ngIf="!isLoadingResume && pdfSrc">
                    <div class="resume-file-link" (click)="openResumeInNewTab()">
                        <div class="resume-pdf-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
                                class="pdf-svg">
                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                <polyline points="14 2 14 8 20 8" />
                                <text x="8" y="16" font-size="6" fill="currentColor" stroke="none">{{ resumeFileType === 'docx' || resumeFileType === 'doc' ? 'DOC' : 'PDF' }}</text>
                            </svg>
                        </div>
                        <span class="resume-file-text">{{selectedUser?.first_name}} Resume.{{ resumeFileType === 'docx' || resumeFileType === 'doc' ? 'DOCX' : 'PDF' }}</span>
                    </div>
                </div>
            </div>

            <!-- Contact Details Section -->
            <div class="details-section-card">
                <h3 class="section-title-new">Contact Details</h3>
                <div class="contact-details-grid">
                    <div class="contact-detail-item">
                        <div class="detail-icon-wrapper contact-icon">
                            <i class="pi pi-envelope"></i>
                        </div>
                        <div class="detail-text-content">
                            <span class="detail-label-new">EMAIL</span>
                            <span class="detail-value-email" (click)="copyToClipboard(selectedUser?.email, 'Email')"
                                [title]="'Click to copy: ' + selectedUser?.email">
                                {{selectedUser?.email || '-'}}
                            </span>
                        </div>
                    </div>
                    <div class="contact-detail-item">
                        <div class="detail-icon-wrapper contact-icon">
                            <i class="pi pi-mobile"></i>
                        </div>
                        <div class="detail-text-content">
                            <span class="detail-label-new">PHONE</span>
                            <span class="detail-value-phone"
                                (click)="copyToClipboard(selectedUser?.mobile_number, 'Phone')"
                                [title]="'Click to copy: ' + selectedUser?.mobile_number">
                                {{selectedUser?.mobile_number || '-'}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Educational Details Section -->
            <div class="details-section-card" *ngIf="selectedUser?.college_names?.ug || selectedUser?.specializations?.ug || 
                  selectedUser?.college_names?.pg || selectedUser?.specializations?.pg || 
                  selectedUser?.college_names?.diploma || selectedUser?.specializations?.diploma">
                <h3 class="section-title-new">Educational Details</h3>

                <!-- UG Details -->
                <div class="edu-card-wrapper"
                    *ngIf="selectedUser?.college_names?.ug || selectedUser?.specializations?.ug || selectedUser?.degrees?.ug">
                    <div class="edu-type-badge">UG</div>
                    <div class="edu-fields-container">
                        <div class="edu-row">
                            <div class="edu-field-box wide">
                                <span class="edu-field-label">DEGREE</span>
                                <span class="edu-field-value">{{ formatEducationValue(selectedUser?.degrees?.ug)
                                    }}</span>
                            </div>
                            <div class="edu-field-box wide">
                                <span class="edu-field-label">SPECIALIZATION</span>
                                <span class="edu-field-value">{{ formatEducationValue(selectedUser?.specializations?.ug)
                                    }}</span>
                            </div>
                        </div>
                        <div class="edu-row">
                            <div class="edu-field-box wide">
                                <span class="edu-field-label">COLLEGE</span>
                                <span class="edu-field-value">{{ selectedUser?.college_names?.ug || '-' }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- PG Details -->
                <div class="edu-card-wrapper"
                    *ngIf="selectedUser?.college_names?.pg || selectedUser?.specializations?.pg || selectedUser?.degrees?.pg">
                    <div class="edu-type-badge">PG</div>
                    <div class="edu-fields-container">
                        <div class="edu-row">
                            <div class="edu-field-box wide">
                                <span class="edu-field-label">DEGREE</span>
                                <span class="edu-field-value">{{ formatEducationValue(selectedUser?.degrees?.pg)
                                    }}</span>
                            </div>
                            <div class="edu-field-box wide">
                                <span class="edu-field-label">SPECIALIZATION</span>
                                <span class="edu-field-value">{{ formatEducationValue(selectedUser?.specializations?.pg)
                                    }}</span>
                            </div>
                        </div>
                        <div class="edu-row">
                            <div class="edu-field-box wide">
                                <span class="edu-field-label">COLLEGE</span>
                                <span class="edu-field-value">{{ selectedUser?.college_names?.pg || '-' }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Diploma Details -->
                <div class="edu-card-wrapper"
                    *ngIf="selectedUser?.college_names?.diploma || selectedUser?.specializations?.diploma || selectedUser?.degrees?.diploma">
                    <div class="edu-type-badge">DIPLOMA</div>
                    <div class="edu-fields-container">
                        <div class="edu-row">
                            <div class="edu-field-box wide">
                                <span class="edu-field-label">DEGREE</span>
                                <span class="edu-field-value">{{
                                    formatEducationValue(selectedUser?.degrees?.diploma) }}</span>
                            </div>
                            <div class="edu-field-box wide">
                                <span class="edu-field-label">SPECIALIZATION</span>
                                <span class="edu-field-value">{{
                                    formatEducationValue(selectedUser?.specializations?.diploma) }}</span>
                            </div>
                        </div>
                        <div class="edu-row">
                            <div class="edu-field-box wide">
                                <span class="edu-field-label">COLLEGE</span>
                                <span class="edu-field-value">{{ selectedUser?.college_names?.diploma || '-' }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>

    <!-- Event Details Tab Content - Outside content-section, no background -->
    <div class="event-tab-content" *ngIf="activeTab === 'events'">

        <!-- Loading State -->
        <div *ngIf="isLoadingEventDetails" class="loading-container">
            <i class="pi pi-spin pi-spinner"></i>
        </div>

        <!-- Event Details Cards -->
        <div class="event-details-container" *ngIf="!isLoadingEventDetails && eventDetails.length > 0">
            <div class="event-card" *ngFor="let event of eventDetails"
                (click)="onEventClick(event.eventId, selectedUser.uuid)" style="cursor: pointer;">
                <h4 class="event-card-title">{{ event.field }}</h4>
                <div class="event-card-grid">
                    <div class="event-field" *ngFor="let detail of event.details">
                        <span class="event-field-label">{{ detail.field }}</span>
                        <span class="event-field-value"
                            [ngClass]="detail.field === 'Status' ? getStatusClass(detail.value) : ''">
                            {{ detail.value }}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Empty State -->
        <div class="empty-state-container" *ngIf="!isLoadingEventDetails && eventDetails.length === 0">
            <div class="empty-state-icon">
                <i class="pi pi-calendar-times"></i>
            </div>
            <h3 class="empty-state-title">No Events Found</h3>
            <p class="empty-state-description">No events found for this candidate.</p>
        </div>

    </div>
</div>

<p-toast></p-toast>